export enum QueryParams{
    AuthoringSystem="authoringSystem",
    AuthoringSystemForeignKey="authoringSystemForeignKey",
    UserLinked="linked",
    PharmacyMedicationOrderId="PharmacyMedicationOrderId"
}

export enum MessageType {
    Warning = "warning",
    Success = "success"
}